import * as yup from 'yup';

export const phoneNumberValidation = () =>
  yup
    .string()
    .matches(/^\+[1-9]\d{1,14}$/, 'Invalid phone number. Must include country code, e.g. +447806574241')
    .max(16, 'Phone number must be 16 characters or less');
